module.exports = ".orange-500-bg {\r\n    background-color: #f28700\r\n}\r\n"